import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import CMMLogo from "./ToolbarLogo/ToolbarLogo";
import Hamburger from "../../UI/Hamburger/Hamburger";
import Icon from "../../UI/Icon/Icon";
import { useTour } from "@reactour/tour";
import { SmallButtonPurple } from "../../UI/Buttons/SmallButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";
const ToolbarContainer = styled.header`
  background-color: white;
`;

const ToolbarInnerContainer = styled.div`
  /* max-width: 1800px; */ //it's disrupting it on big screen 4k
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  padding: 3px 12px 3px 6px;

  @media screen and (min-width: 769px) {
    padding: 10px;
  }
`;

const DropDownContentItem = styled.li`
  height: 40px;
  line-height: 40px;
  width: 152px;
  vertical-align: middle;
  opacity: 0.85;
  list-style-type: none;
  text-decoration: none;

  &:hover {
    background-color: #f1f7fb;
  }
`;

const DropdownContentWrapper = styled.div`
  position: absolute;
`;

const DropDownContent = styled.div`
  display: none;
  position: relative;
  right: 5px;
  bottom: -60px;
  max-width: 154px;
  border: 1px solid #ced0da;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 8px 16px 0 rgba(12, 0, 51, 0.1);
  z-index: 5;
`;

const DropDown = styled.div`
  height: 50px;
  text-align: center;
  padding: 13px;
  margin: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;

  &:hover ${DropDownContent} {
    display: block;
  }
  @media screen and (min-width: 769px) {
    display: flex;
  }
  @media screen and (max-width: 769px) {
    display: none;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
`;
const IconWrapper = styled.div`
  margin: 0px 10px;

  @media screen and (max-width: 769px) {
    display: none;
  }
`;
const toolbar = (props) => {
  const history = useHistory();
  const { setIsOpen, isOpen, currentStep, setCurrentStep } = useTour();
  useEffect(() => {
    if (
      (currentStep === 10 || currentStep === 11) &&
      isOpen &&
      screen.width <= 769
    ) {
      props.sideDrawerOpener();
    } else {
      props.sideDrawerCloser();
    }
  }, [currentStep, isOpen, props.highlightedIndex, props.videoUrl]);
  useEffect(() => {
    if (
      props.videoUrl &&
      window.location.href !== `${process.env.REACT_APP_HOST}/home`
    ) {
      setCurrentStep(7);
      setTimeout(() => {
        setCurrentStep(6);
      }, 1500);
    }
  }, [props.videoUrl]);

  if (
    currentStep === 5 &&
    isOpen &&
    window.location.href !== `${process.env.REACT_APP_HOST}/home`
  ) {
    setCurrentStep(4);
    setTimeout(() => {
      setCurrentStep(5);
    }, 1500);
    history.goBack();
  }

  return (
    <ToolbarContainer>
      <ToolbarInnerContainer>
        <CMMLogo />

        <ButtonsContainer>
          <SmallButtonPurple
            onClick={() => {
              if (window.location.pathname !== '/home') {
                history.push('/home');
              }
              setCurrentStep(0);
              setIsOpen(true);
            }}
            style={{ padding: "0px 20px", height: "60%" }}
          >
            Take Tour
          </SmallButtonPurple>

          <DropDown>
            {props.name}
            <IconWrapper>
              {" "}
              <Icon name="menu_list_dropdown" alt="search" />
            </IconWrapper>
            <DropdownContentWrapper>
              <DropDownContent
                style={{
                  display:
                    isOpen && (currentStep === 10 || currentStep === 11)
                      ? "block"
                      : "",
                }}
              >
                {/*<DropDownContentItem onClick={props.showSettings}>Edit Profile</DropDownContentItem>*/}
                <DropDownContentItem
                  onClick={props.showSettings}
                  className="twelth-step"
                >
                  Settings
                </DropDownContentItem>
                {/*<DropDownContentItem> Feedback </DropDownContentItem>*/}
                <DropDownContentItem>
                  <Link to="/auth/logout" style={{ textDecoration: "none" }}>
                    Sign Out
                  </Link>
                </DropDownContentItem>
              </DropDownContent>
            </DropdownContentWrapper>
          </DropDown>
        </ButtonsContainer>

        <Hamburger toggle={props.toggle} />
      </ToolbarInnerContainer>
    </ToolbarContainer>
  );
};
const mapStateToProps = (state) => {
  return {
    videoUrl: state.specificMeeting.videoUrl,
  };
};
// Connect the component to the Redux store
export default connect(mapStateToProps)(toolbar);
